import { ImageList } from './image_list';
import Alpine from 'alpinejs';

Alpine.data('imageList', (imageList: HTMLElement) => new ImageList(imageList));
